import { useLazyQuery } from '@apollo/client'
import {
  InsuranceTestsResultsAnalytics,
  InsuranceTestsResultsAnalyticsVariables,
} from '../../types'
import { INSURANCE_TESTS_RESULTS_ANALYTICS } from './operations'

export const useInsuranceTestsResultsAnalytics = () => {
  const insuranceTestAnalyticsQuery = useLazyQuery<
    InsuranceTestsResultsAnalytics,
    InsuranceTestsResultsAnalyticsVariables
  >(INSURANCE_TESTS_RESULTS_ANALYTICS)

  return insuranceTestAnalyticsQuery
}
